export const DPCARD_FORM_URL = 'https://cl.s13.exct.net/DEManager.aspx';
export const DPCARD_FORM_CLIENT_ID = '546000668';
export const DPCARD_FORM_DE_EXTERNAL_KEY = 'FC25C78B-0988-4C30-82DB-85D5FA96B54D';
export const DPCARD_FORM_SUCCESS_URL = 'https://www.dportenis.mx/success';
export const DPCARD_FORM_ERROR_URL = 'https://www.dportenis.mx/failed';
export const DPCARD_FORM_ACTION = 'add/update';
export const DPCARD_FORM_RETURN_XML = '0';
